import { toast } from "sonner"
import { createElement } from "react"
import { isNormalizedError } from "@/shared/api"
import { ToastCard } from "@/components/ui/toast-card"
import { showErrorOverlay } from "@/shared/error-overlay"

function makeId() {
  return Math.random().toString(36).slice(2)
}

export function toastSuccess(message: string): void {
  const id = makeId()
  toast.custom(
    () => createElement(ToastCard, { id, type: "success", message }),
    { id, duration: 3000 },
  )
}

export function toastWarning(message: string): void {
  const id = makeId()
  toast.custom(
    () => createElement(ToastCard, { id, type: "warning", message }),
    { id, duration: 3000 },
  )
}

export function toastInfo(message: string): void {
  const id = makeId()
  toast.custom(
    () => createElement(ToastCard, { id, type: "info", message }),
    { id, duration: 3000 },
  )
}

const ERROR_TOAST_ID = "global-error-toast"

export function toastError(fallback: string, err: unknown, forceMessage = false): void {
  const message = forceMessage || !isNormalizedError(err) ? fallback : (err.message ?? fallback)
  showErrorOverlay()
  toast.custom(
    () => createElement(ToastCard, { id: ERROR_TOAST_ID, type: "error", message }),
    { id: ERROR_TOAST_ID, duration: Infinity },
  )
}

export function toastErrorMessage(message: string): void {
  showErrorOverlay()
  toast.custom(
    () => createElement(ToastCard, { id: ERROR_TOAST_ID, type: "error", message }),
    { id: ERROR_TOAST_ID, duration: Infinity },
  )
}

/** @deprecated Use toastSuccess/toastError/toastWarning instead */
export function dismissToastOptions() {
  return {
    id: makeId(),
    duration: Infinity,
    cancel: { label: "Kapat", onClick: () => {} },
  }
}

/** @deprecated Use toastError instead */
export function errorToastOptions(message: string) {
  return {
    id: makeId(),
    duration: Infinity,
    action: { label: "Kopyala", onClick: () => navigator.clipboard.writeText(message) },
    cancel: { label: "Kapat", onClick: () => {} },
  }
}
